import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {catchError, throwError} from "rxjs";
import {StatusMessageComponent} from "../../libs/status-message/status-message.component";
import {StatusMessageEnum} from "../../enums/status-message/status-message.enum";
import {MatSnackBar} from "@angular/material/snack-bar";
import {inject} from "@angular/core";

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {

  const snackBar = inject(MatSnackBar);
  const showErrorMessage = (err: string) => {
    snackBar.openFromComponent(StatusMessageComponent, {
      panelClass: StatusMessageEnum.error,
      data: err,
    });
  }

  return next(req).pipe(
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          showErrorMessage(`Unauthorized request. ${error.error.message}`);
        } else  if (error.error.message) {
          showErrorMessage(`HTTP error. ${error.error.message}`);
          console.log(error);
        }
      } else {
        showErrorMessage(`An error occurred: ${error.error.message}`);
      }
      return throwError(() => error);
    })
  );
};
